import type { EdithReqOpts, EdithUser } from '@ali/edith-sdk';
import EdithSDK from '@ali/edith-sdk';

import { EDITH_ENV, getProcessEnv } from './codebase';

let unionEdithClient: EdithSDK | undefined;
function getEdithClient(config: string | EdithReqOpts = {}) {
  if (unionEdithClient) return unionEdithClient;
  let curConfig: EdithReqOpts;
  if (typeof config === 'string') {
    curConfig = { env: config };
  } else {
    curConfig = config;
  }

  const env = curConfig.env || getProcessEnv(EDITH_ENV);
  let server;

  Reflect.deleteProperty(curConfig, 'env');

  switch (env) {
    case 'local':
      server = 'http://localhost:6001';
      break;
    case 'test':
    case 'daily':
      server = 'https://daily-edith.alibaba-inc.com';
      break;
    case 'prepub':
    case 'pre':
      server = 'https://pre-edith.alibaba-inc.com';
      break;
    default:
      server = 'https://edith.alibaba-inc.com';
  }
  unionEdithClient = new EdithSDK({
    server,
    ...curConfig,
  });
  return unionEdithClient;
}

/* let cachedEdithUser: EdithUser | undefined;
export async function getEdithUser(clientInstance?: EdithSDK, noCache?: boolean) {
  if (!noCache && cachedEdithUser) {
    return cachedEdithUser;
  }
  const client = clientInstance || getEdithClient();
  const user = await client.login();
  cachedEdithUser = user;
  return user;
} */

// 解决上面 getEdithUser 的 eslint require-atomic-updates 问题的实现
let cachedEdithUser: EdithUser | undefined;
let loginPromise: Promise<EdithUser> | undefined;
export async function getEdithUser(clientInstance?: EdithSDK, noCache?: boolean) {
  if (!noCache && cachedEdithUser) {
    return cachedEdithUser;
  }

  // 如果已经有一个正在进行中的登录请求，等待这个请求完成。
  if (loginPromise) {
    return await loginPromise;
  }

  // 创建一个新的登录 Promise，并存储在一个变量中，以确保同时只有一个登录请求。
  loginPromise = (async () => {
    try {
      const client = clientInstance || getEdithClient();
      const user = await client.login();
      // 只有请求成功后才更新缓存的用户
      cachedEdithUser = user;
      return user;
    } finally {
      // 清除登录 Promise，这样在下次调用时可以创建新的登录请求。
      loginPromise = undefined;
    }
  })();

  return await loginPromise;
}

async function getEdithToken(client: EdithSDK) {
  const user = await getEdithUser(client);
  // eslint-disable-next-line no-underscore-dangle
  return user.__token;
}

export async function getEdithProxyApi<T>(api: string, params: EdithReqOpts = {}) {
  if (/^\/v1.0\//iu.test(api)) {
    params.query = {
      ...params.query,
      version: 1,
    };
    /* // edith 服务环境一键切换，兜底是线上
    if (!params.env) {
      params.env = 'local'; // 本地调试
      params.env = 'pre'; // 预发测试
    } */
  }

  const client = getEdithClient(params.env);
  const token = await getEdithToken(client);
  const query = params.method === 'post' || params.post || params.body ? 'body' : 'query';
  const o2Token = params.o2ClientToken;

  Reflect.deleteProperty(params, 'env');
  Reflect.deleteProperty(params, 'post');
  Reflect.deleteProperty(params, 'method');
  Reflect.deleteProperty(params, 'o2ClientToken');

  const q = params[query] || {};
  params[query] = { token, clientToken: o2Token, ...q };

  return await client.proxy<T>(api, params);
}
